/**
 * Created by seaasun on 2017/12/15.
 */

import utils from './utils/index'
// import _ from 'lodash'

export function numberFormat (num, symbol, rounding, decimal, isThousands) {
  return utils.numberFormat(num, symbol, rounding, decimal, isThousands)
}

export function formatMonth (date) {
  let month = {
    0: 'JAN',
    1: 'FEB',
    2: 'MAR',
    3: 'APR',
    4: 'MAY',
    5: 'JUN',
    6: 'JUL',
    7: 'AUG',
    8: 'SEP',
    9: 'OCT',
    10: 'NOV',
    11: 'DEC'
  }
  try {
    return month[date.getMonth()]
  } catch (e) {
    return ''
  }
}

export function formatDay (date) {
  try {
    return date.getDate()
  } catch (e) {
    return ''
  }
}

export function formatYear (date) {
  try {
    return date.getFullYear()
  } catch (e) {
    return ''
  }
}

export function formatDate (date, format) {
  try {
    return utils.dateFormat(date, format)
  } catch (e) {
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/assets/filters.js